import { defineComponent as _defineComponent } from 'vue'
import Button from '@/components/buttons/Button.vue';
import CloseButton from '@/components/buttons/dedicated/CloseButton.vue';
import AreaSessionFormItem from '@/components/form/AreaSessionFormItem.vue';
import AreaSessionsForm from '@/components/form/AreaSessionsForm.vue';
import BreakDetails from '@/components/form/BreakDetails.vue';
import BreakDetailsItem from '@/components/form/BreakDetailsItem.vue';
import BottomSheet from '@/components/modal/BottomSheet.vue';
import { Icon } from '@/lib/enum/Icon';
import {
  ScheduledBreakFormItemType,
  ShiftAreaSessionFormItemType,
} from '@/types/shiftSessionsForm';
import { viewport } from '@/util/windowFunctions';
import useVuelidate from '@vuelidate/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftSessionsForm',
  props: {
    date: null,
    shiftStartTime: null,
    shiftEndTime: null,
    shiftLocationId: null,
    scheduledBreaks: null,
    areaSessions: null,
    updateBreaks: null,
    updateAreas: null
  },
  emits: ["addBreak", "addArea", "submit", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'addBreak'): void;
  (e: 'addArea'): void;
  (e: 'submit'): void;
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  date: Date;
  shiftStartTime: string;
  shiftEndTime: string;
  shiftLocationId: number;
  scheduledBreaks: ScheduledBreakFormItemType[];
  areaSessions: ShiftAreaSessionFormItemType[];
  updateBreaks: (breaks: ScheduledBreakFormItemType[]) => void;
  updateAreas: (sessions: ShiftAreaSessionFormItemType[]) => void;
}





// use vuelidate state from child LocationForm.vue component
// https://vuelidate-next.netlify.app/advanced_usage.html#nested-validations
const v$ = useVuelidate();

const updateScheduledBreaks = (data: ScheduledBreakFormItemType[]) => {
  props.updateBreaks(data);
};

return { __sfc: true,props, emit, v$, updateScheduledBreaks, Button, CloseButton, AreaSessionFormItem, AreaSessionsForm, BreakDetails, BreakDetailsItem, BottomSheet, Icon, viewport }
}

})